module.exports = __webpack_public_path__ + "static/media/img-upload-video.c55ea5d2.svg";